export const getPreview = (editor) => editor.preview;
